export default "__VITE_ASSET__e832005e__"